module.exports = __webpack_public_path__ + "static/media/screenshot.396e9c52.png";